import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { generateUrls } from '@hooks/useTrainingModule'

import { TrainingModuleModel } from '@models/types'

const generateTabBarItems = (trainingModule: TrainingModuleModel) => {
  const urls = generateUrls(trainingModule)
  const { editTrainingModuleUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editTrainingModuleUrl,
      key: 'details',
      title: trainingModule?.title || 'Training Module Details',
    },
  ]
}

export default generateTabBarItems
